import { render, staticRenderFns } from "./CakeOrderForm.vue?vue&type=template&id=05b3dd36&scoped=true"
import script from "./CakeOrderForm.vue?vue&type=script&lang=js"
export * from "./CakeOrderForm.vue?vue&type=script&lang=js"
import style0 from "./CakeOrderForm.vue?vue&type=style&index=0&id=05b3dd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3dd36",
  null
  
)

export default component.exports